<p><b>Обычный выбор</b></p>
<div class="box">
    <form [formGroup]="form">
        <pa-select-button [fullWidth]="true" formControlName="city" [options]="cities" label="Выберите город"></pa-select-button>
    </form>
</div>

<p><b>С подсказкой</b></p>
<div class="box">
    <form [formGroup]="form">
        <pa-select-button formControlName="status" [options]="statuses" label="Статус" tooltip="Выберите текущий статус"></pa-select-button>
    </form>
</div>

<p><b>Выключенный</b></p>
<div class="box">
    <form [formGroup]="form2">
        <pa-select-button formControlName="city" [options]="cities" label="Город"></pa-select-button>
    </form>
</div>

<p><b>Обязательное поле с ошибкой</b></p>
<div class="box">
    <form [formGroup]="form3">
        <pa-select-button
          formControlName="status"
          [options]="statuses"
          label="Статус"
          hint="Это поле обязательно для заполнения"
        ></pa-select-button>
    </form>
</div>

<p><b>Множественный выбор</b></p>
<div class="box">
    <form [formGroup]="form4">
        <pa-select-button formControlName="priority" [options]="priorities" label="Приоритеты" [multiple]="true"></pa-select-button>
    </form>
</div>

<p><b>Без возможности очистки</b></p>
<div class="box">
    <form [formGroup]="form">
        <pa-select-button formControlName="priority" [options]="priorities" label="Приоритет" [allowEmpty]="false"></pa-select-button>
    </form>
</div>


<p><b>Кастомные сообщения ошибок select-button</b></p>
<div class="box">
    <form [formGroup]="form5">
        <pa-select-button
          formControlName="priority"
          [options]="priorities"
          label="Приоритеты"
          [customErrorMessages]="selectButtonErrorMessages"
        ></pa-select-button>
    </form>
</div>
